module.exports = __webpack_public_path__ + "static/media/bet-logo-stc.541bb59c.png";